import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

// "Sur cette page" anchors: matches a toc label to the id given to its
// section heading below, e.g. "Pièges fréquents" -> "toc-pieges-frequents".
const slug = (label) => "toc-" + label.toLowerCase()
  .normalize("NFD").replace(/[̀-ͯ]/g, "")
  .replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function Article({ v }) {
  const art = v.article;
  return (
    <div className="nd-article-grid" style={pstyle("display:grid; grid-template-columns:236px minmax(0,1fr) 220px; min-height:calc(100vh - 60px);")}>
      <aside className="nd-article-aside-left" style={pstyle("border-right:1px solid oklch(0.95 0.006 85); padding:28px 0 28px 44px; display:flex; flex-direction:column; gap:2px;")}>
        <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60); padding-bottom:10px;")}>{v.articleDomain}</div>
        {v.siblingArticles.map((a, i) => (
          <Hoverable
            key={i}
            onClick={a.onClick}
            style={pstyle("font-size:13.5px; padding:6px 12px 6px 10px; margin-right:12px; border-radius:6px; cursor:pointer;", { color: a.color, background: a.bg })}
            hoverStyle={{ color: "oklch(0.46 0.075 55)" }}
          >
            {a.title}
          </Hoverable>
        ))}
      </aside>

      <main className="nd-article-main" style={pstyle("padding:36px 56px 72px; display:flex; flex-direction:column; gap:28px; max-width:820px;")}>
        <div style={pstyle("display:flex; align-items:center; gap:8px; font-size:12.5px; color:oklch(0.53 0.015 60);")}>
          <button type="button" onClick={v.goHome} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Wiki</button><span>/</span>
          <span>{v.articleDomain}</span><span>/</span>
          <span style={pstyle("color:oklch(0.35 0.015 60);")}>{art.short}</span>
        </div>

        <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
          <h1 style={pstyle("margin:0; font-size:34px; font-weight:600; letter-spacing:-0.025em;")}>{art.title}</h1>
          <p style={pstyle("margin:0; font-size:16.5px; line-height:1.7; color:oklch(0.4 0.015 60); text-wrap:pretty;")}>{art.intro}</p>
          <div style={pstyle("display:flex; align-items:center; gap:14px; font-size:12.5px; color:oklch(0.55 0.015 60); padding-top:4px;")}>
            <span>{art.meta}</span>
            <span style={pstyle("margin-left:auto; display:flex; gap:14px; align-items:center;")}>
              <button type="button" onClick={v.toggleBookmark} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; cursor:pointer; color:oklch(0.46 0.075 55);")}>{v.bookmarkLabel}</button>
            </span>
          </div>
        </div>

        <div style={pstyle("display:flex; gap:22px; border-bottom:1px solid oklch(0.94 0.006 85);")}>
          {v.articleTabs.map((t, i) => (
            <button key={i} type="button" onClick={t.onClick} style={pstyle("background:none; border:none; border-bottom-width:2px; border-bottom-style:solid; padding:0 0 10px; margin:0 0 -1px; font:inherit; font-size:13.5px;", { borderBottomColor: t.line, color: t.color, cursor: "pointer" })}>{t.label}</button>
          ))}
        </div>

        {v.tabArticle && (
          <div style={pstyle("display:flex; flex-direction:column; gap:28px;")}>
            <div style={pstyle("border-left:2px solid oklch(0.46 0.075 55); padding:2px 0 2px 16px; font-size:14.5px; line-height:1.65; color:oklch(0.32 0.015 60);")}>{art.summary}</div>

            {v.hasBody && (
              // Rendered from the fiche's Markdown body beyond the intro/
              // "En bref" quote (see docs/content-authoring.md); already
              // sanitized by DOMPurify at load time (src/content/loadArticles.js),
              // so this is the one legitimate dangerouslySetInnerHTML in
              // the app. Typography lives in .nd-article-body (index.css) —
              // pstyle() can't reach into markdown-it's generated markup.
              <div className="nd-article-body" dangerouslySetInnerHTML={{ __html: v.bodyHtml }} />
            )}

            {v.hasTable && (
              <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
                <h2 id="toc-ordre-de-selection" style={pstyle("margin:0; font-size:20px; font-weight:600; letter-spacing:-0.015em; scroll-margin-top:24px;")}>Ordre de sélection</h2>
                <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; overflow:hidden;")}>
                  <div style={pstyle("display:grid; grid-template-columns:44px 1fr 1.4fr 110px; font-size:12px; font-weight:600; color:oklch(0.5 0.015 60); background:oklch(0.985 0.005 85); border-bottom:1px solid oklch(0.93 0.008 85);")}>
                    <span style={pstyle("padding:9px 12px;")}>#</span><span style={pstyle("padding:9px 12px;")}>Attribut</span><span style={pstyle("padding:9px 12px;")}>Règle</span><span style={pstyle("padding:9px 12px;")}>Portée</span>
                  </div>
                  {v.bgpAttrs.map((r, i) => (
                    <div key={i} style={pstyle("display:grid; grid-template-columns:44px 1fr 1.4fr 110px; font-size:13.5px; border-bottom:1px solid oklch(0.96 0.006 85);")}>
                      <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.56 0.015 60);")}>{r.n}</span>
                      <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12.5px;")}>{r.attr}</span>
                      <span style={pstyle("padding:10px 12px; color:oklch(0.42 0.015 60);")}>{r.rule}</span>
                      <span style={pstyle("padding:10px 12px; font-size:12.5px; color:oklch(0.55 0.015 60);")}>{r.scope}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
              <h2 id="toc-verifier-en-production" style={pstyle("margin:0; font-size:20px; font-weight:600; letter-spacing:-0.015em; scroll-margin-top:24px;")}>Vérifier en production</h2>
              <div style={pstyle("border:1px solid oklch(0.9 0.02 60); border-radius:8px; overflow:hidden; background:oklch(0.19 0.012 60);")}>
                <div style={pstyle("display:flex; align-items:center; gap:12px; padding:8px 14px; border-bottom:1px solid oklch(0.28 0.014 60); font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.72 0.015 70); background:oklch(0.23 0.014 60);")}>
                  {v.platforms.map((p, i) => (
                    <button key={i} type="button" onClick={p.onClick} style={pstyle("background:none; border:none; font:inherit; cursor:pointer; padding:3px 9px; border-radius:999px;", { color: p.color, background: p.bg, fontWeight: p.weight })}>{p.name}</button>
                  ))}
                  <button type="button" onClick={v.copyCli} style={pstyle("background:none; border:none; padding:0; margin-left:auto; font:inherit; cursor:pointer; color:oklch(0.8 0.09 85);")}>{v.copyLabel}</button>
                </div>
                <pre style={pstyle("margin:0; padding:16px 18px; font-family:'IBM Plex Mono', monospace; font-size:12.5px; line-height:1.8; color:oklch(0.9 0.02 90); white-space:pre-wrap;")}>{v.cliCode}</pre>
              </div>
            </div>

            <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
              <h2 id="toc-pieges-frequents" style={pstyle("margin:0; font-size:20px; font-weight:600; letter-spacing:-0.015em; scroll-margin-top:24px;")}>Pièges fréquents</h2>
              <div style={pstyle("display:flex; flex-direction:column; gap:9px; font-size:15px; line-height:1.7; color:oklch(0.38 0.015 60);")}>
                {art.pitfalls.map((p, i) => <div key={i}>— {p}</div>)}
              </div>
            </div>

            <div style={pstyle("display:flex; gap:12px; padding-top:8px;")}>
              <Hoverable
                onClick={v.prevArticle}
                style={pstyle("flex:1; border:1px solid oklch(0.93 0.008 85); border-radius:8px; padding:14px 16px; display:flex; flex-direction:column; gap:3px; cursor:pointer;")}
                hoverStyle={{ borderColor: "oklch(0.8 0.012 85)" }}
              >
                <span style={pstyle("font-size:12px; color:oklch(0.53 0.015 60);")}>Précédent</span>
                <span style={pstyle("font-size:14.5px;")}>{v.prevTitle}</span>
              </Hoverable>
              <Hoverable
                onClick={v.nextArticle}
                style={pstyle("flex:1; border:1px solid oklch(0.93 0.008 85); border-radius:8px; padding:14px 16px; display:flex; flex-direction:column; gap:3px; text-align:right; cursor:pointer;")}
                hoverStyle={{ borderColor: "oklch(0.8 0.012 85)" }}
              >
                <span style={pstyle("font-size:12px; color:oklch(0.53 0.015 60);")}>Suivant</span>
                <span style={pstyle("font-size:14.5px;")}>{v.nextTitle}</span>
              </Hoverable>
            </div>
          </div>
        )}

        {v.tabNotes && (
          <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
            <div style={pstyle("display:flex; align-items:baseline; gap:14px;")}>
              <span style={pstyle("font-size:13px; color:oklch(0.5 0.015 60);")}>Privé — visible par vous seul, conservé sur cet appareil.</span>
              <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.53 0.015 60);")}>{v.noteStat}</span>
              <button type="button" onClick={v.exportNotes} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; font-size:13px; color:oklch(0.46 0.075 55); cursor:pointer;")}>Exporter en .md</button>
            </div>
            <textarea
              value={v.noteText}
              onChange={v.onNote}
              placeholder="Ce que vous avez appris en incident, la commande qui a servi, le numéro de ticket…"
              style={pstyle("width:100%; min-height:220px; resize:vertical; border:1px solid oklch(0.92 0.008 85); border-radius:8px; padding:16px 18px; font-family:'IBM Plex Sans', Helvetica, sans-serif; font-size:14.5px; line-height:1.7; color:oklch(0.26 0.015 60); outline:none; background:oklch(0.995 0.003 85);")}
            />
            {v.hasOtherNotes && (
              <div style={pstyle("display:flex; flex-direction:column; gap:10px; border-top:1px solid oklch(0.95 0.006 85); padding-top:16px;")}>
                <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Vos autres notes</div>
                {v.otherNotes.map((n, i) => (
                  <Hoverable
                    key={i}
                    onClick={n.onClick}
                    style={pstyle("display:flex; gap:14px; font-size:13.5px; color:oklch(0.4 0.015 60); cursor:pointer;")}
                    hoverStyle={{ color: "oklch(0.46 0.075 55)" }}
                  >
                    <span style={pstyle("width:280px; flex:none;")}>{n.title}</span>
                    <span style={pstyle("color:oklch(0.53 0.015 60); flex:1;")}>{n.excerpt}</span>
                  </Hoverable>
                ))}
              </div>
            )}
          </div>
        )}
      </main>

      <aside className="nd-article-aside-right" style={pstyle("border-left:1px solid oklch(0.95 0.006 85); padding:36px 24px; display:flex; flex-direction:column; gap:10px;")}>
        <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Sur cette page</div>
        {v.toc.map((t, i) => (
          <Hoverable
            key={i}
            onClick={() => document.getElementById(slug(t))?.scrollIntoView({ behavior: "smooth", block: "start" })}
            style={pstyle("font-size:13px; color:oklch(0.45 0.015 60); padding:3px 0; cursor:pointer;")}
            hoverStyle={{ color: "oklch(0.46 0.075 55)" }}
          >{t}</Hoverable>
        ))}
        {v.bookmarked && (
          <div style={pstyle("margin-top:18px; padding-top:16px; border-top:1px solid oklch(0.95 0.006 85); font-size:12.5px; color:oklch(0.46 0.075 55);")}>Ajouté à vos favoris</div>
        )}
      </aside>
    </div>
  );
}
